export default {
    login: {
        title: 'User Login',
        username: ' PANACRO Copyright',
        button: 'Sign in',
        confirmBtn: 'Confirm',
        forgotPassword: 'Forgot Password',
        userAgreement: 'the User Agreement',
        privacyPolicy: 'Privacy Policy',
        aggreStr1: 'I have read and agree to',
        aggreStr2: 'and',
        agreeStr3: '. Inactive accounts will be automatically activated upon login.',
        switchAccount: 'Switch Account',
        confirmlogin: 'Confirm Login',
        platformPrivacyPolicy: "Privacy Policy for Clinical Trial Cloud Platform",
        platformUserAgreement: 'Clinical Trial Cloud Platform User Agreement',
        tip: 'Kind Reminder',
        disagree: 'Disagree',
        agreeStr4: 'To better protect your legal rights and interests, please read and agree to',
        tabName1: 'Account Login',
        tabName2: 'SMS Verification Login',
        placeholderStr1: 'Please enter your username, email, or phone number',
        placeholderStr2: 'Please enter the password',
        placeholderStr3: 'Please enter your phone number',
        placeholderStr4: 'Please enter the verification code',
        placeholderStr5: 'Please enter your email, or phone number',
        placeholderStr6: 'Please enter your email',
        verificationCode: 'Get verification code',
        retrievePassword: 'Retrieve Password',
        resetPassword: 'Reset password',
        next: 'Next',
        backLogin: 'Return to login',
        warnStr1: 'Please contact the administrator',
    },
    iphone: {
        warnStr1: 'Please enter a correct phone number',
        warnStr2: 'Sent successfully! Please find attached',
        warnStr3: 'Resend',
        warnStr4: 'Click the button to proceed with email verification',
        warnStr5: 'Click the button to verify via mobile phone',
        warnStr6: 'The account has not been registered yet',
        warnStr7: 'Sent successfully! Please find attached',
        warnStr8: 'The verification code has been sent to your email',
        warnStr9: 'Verify mobile number',
    },
    forgetPassword: {
        tpisStr1: 'Confirm that the new password cannot be shorter than 6 characters',
        tpisStr2: 'The new password must be at least 6 characters long',
        tpisStr3: 'Confirm that the new password does not meet the format requirements',
        tpisStr4: 'The new password does not meet the format requirements',
        tpisStr5: 'The new password does not match the confirmation password',
        tpisStr6: 'New password',
        tpisStr7: 'Length: 6–18 characters. Must contain at least 2 of the following: numbers, uppercase letters, lowercase letters, or punctuation marks',
        tpisStr8: 'Please enter a new password',
        tpisStr9: 'Confirm new password',
        tpisStr10: 'Please enter the confirmation password',
        tpisStr11: 'Reset password',
        tpisStr12: 'Password reset successful',
        tpisStr13: 'Sign in',
        tpisStr14: 'Set a new password',
        tpisStr15: 'Confirm and sign in',
        tpisStr16: 'New users or users resetting their passwords need to set a new password when logging in for the first time',
    },
    validate: {
        str1: 'Verification code has been sent. Please check your SMS and enter the received verification code',
        str2: 'The verification code has been sent to',
        str3: ',Please check your email and enter the verification code you received',
        str4: 'Please enter the verification code',
        str5: "Can't receive the verification code?",
        str6: 'Change a phone number',
        str7: 'Change email',
        str8: 'Next',
        str9: 'Email verification',
        str10: '（The current user has not bound an email address. Please contact the administrator）',
        warnStr1: 'Please enter your phone number',
        warnStr2: 'Please enter a correct phone number',
        warnStr3: 'Please enter your username',
        warnStr4: 'Please enter the password',
        warnStr5: 'Please enter the 6-digit verification code',
        warnStr6: 'Please enter the correct verification code',
        warnStr7: 'Please enter your phone number or email',
        warnStr8: 'Please enter a correct phone number or email address',
        warnStr9: 'Please enter a new password',
        warnStr10: 'Please enter the confirmation password',
    },
}


